import {
  APP_BOOTSTRAP_LISTENER, ApplicationRef, ComponentRef, EnvironmentInjector, Provider, createComponent, inject
} from '@angular/core';
import { CONSENT_APP_CONFIG, ConsentAppConfig } from 'analytics';
import { CookieConsentOverlayComponent } from './cookie-consent-overlay.component';

/**
 * Switches the cookie banner on for an app (`createAppConfig({ consent: {...} })`).
 *
 * The overlay is not placed in any template: once the root component is
 * bootstrapped, ONE instance is created and appended to `document.body`, so it
 * sits above every route — inside the default layout and on the public pages
 * outside it — without touching the apps' app.component.
 */
export function provideCookieConsent(config: ConsentAppConfig): Provider[] {
  return [
    { provide: CONSENT_APP_CONFIG, useValue: config },
    ...(config.enabled ? [{
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: () => {
        const appRef = inject(ApplicationRef);
        const environmentInjector = inject(EnvironmentInjector);
        let mounted = false;
        return (_root: ComponentRef<unknown>) => {
          if (mounted || typeof document === 'undefined') return;
          mounted = true;
          try {
            const ref = createComponent(CookieConsentOverlayComponent, { environmentInjector });
            appRef.attachView(ref.hostView);
            document.body.appendChild(ref.location.nativeElement);
          } catch { /* the app must start even if the banner cannot */ }
        };
      }
    }] : [])
  ];
}
